export const MIN_SCALE = 0.5;
export const MAX_SCALE = 2.5;
